import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const purchaseOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "账号",
            prop: "account",
            search: true,
            type: 'input',
            span: 13,
            editVisdiplay: false

        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
            search: true,
            span: 13,
            editVisdiplay: false,
            width: "110",
        },
        {
            label: "法人名称",
            prop: "name",
            width: "110",
            editVisdiplay: false,
            search: true,
            type: 'input',
        },
        {
            label: "店铺地址",
            prop: "address",
            type: "input",
            span: 13,
            editVisdiplay: false,
            search: true,
        },
        {
            label: "采购分类权限",
            prop: "purchasePower",
            formsolt: true,
            span: 24,
            type: "radio",
            solt: true,
        },
        // {
        //     label: "采购分类权限",
        //     prop:"purchasePower",
        //     formsolt: true,
        //     span: 24,
        //     type: "radio",
        // },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            span: 13,
            editVisdiplay: false
        },
        {
            label: "操作人",
            prop: "updateName",
            // solt: true,
            span: 13,
            editVisdiplay: false,
            type: 'input',
        },
        {
            label: "支付时间区间",
            prop: "payTimeInterval",
            type: "datetimerange",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            hide: true,
            addVisdiplay: false,
            span: 13,
            editVisdiplay: false
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            // search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};